import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "heading"];
import { cloneElement, useId } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLi = styled.li.withConfig({
  displayName: "MenuSection__StyledLi",
  componentId: "v5rg08-0"
})(["list-style-type:none;ul{margin:0;padding:0;}"]);
export const MenuSection = _ref => {
  let {
      children,
      heading
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const headingId = useId();
  const headingWithId = /*#__PURE__*/cloneElement(heading, {
    id: headingId
  });
  return /*#__PURE__*/_jsxs(StyledLi, Object.assign({
    role: "none"
  }, rest, {
    children: [headingWithId, /*#__PURE__*/_jsx("ul", {
      role: "group",
      "aria-labelledby": headingId,
      children: children
    })]
  }));
};